import { HUBFARM_BORDER_RADIUS, HUBFARM_BOX_SHADOW, HUBFARM_COLORS, HUBFARM_FONTS, HUBFARM_LAYOUT, HUBFARM_SPACING, } from './hubfarmThemeConf';
import { createTheme } from '@material-ui/core/styles';
import { border, toCssValue } from '../themeUtils';
const hubfarmThemeConf = {
    color: {
        primary: {
            lightest: HUBFARM_COLORS.primary.lightest,
            light: HUBFARM_COLORS.primary.light,
            main: HUBFARM_COLORS.primary.main,
            dark: HUBFARM_COLORS.primary.dark,
            darkest: HUBFARM_COLORS.primary.darkest,
        },
        brand: {
            lightest: HUBFARM_COLORS.brand.lightest,
            light: HUBFARM_COLORS.brand.light,
            main: HUBFARM_COLORS.brand.main,
            dark: HUBFARM_COLORS.brand.dark,
            darkest: HUBFARM_COLORS.brand.darkest,
        },
        success: {
            light: HUBFARM_COLORS.success.light,
            main: HUBFARM_COLORS.success.main,
            dark: HUBFARM_COLORS.success.dark,
        },
        error: {
            lightest: HUBFARM_COLORS.error.lightest,
            light: HUBFARM_COLORS.error.light,
            main: HUBFARM_COLORS.error.main,
            dark: HUBFARM_COLORS.error.dark,
        },
        warning: {
            lightest: HUBFARM_COLORS.warning.lightest,
            light: HUBFARM_COLORS.warning.light,
            main: HUBFARM_COLORS.warning.main,
        },
        grey: {
            lightest: HUBFARM_COLORS.grey.lightest,
            light: HUBFARM_COLORS.grey.light,
            default: HUBFARM_COLORS.grey.default,
            dark: HUBFARM_COLORS.grey.dark,
            darkest: HUBFARM_COLORS.grey.darkest,
        },
        input: {
            placeholder: HUBFARM_COLORS.grey.default,
            border: HUBFARM_COLORS.grey.default,
        },
        background: {
            body: HUBFARM_COLORS.background.body,
            light: HUBFARM_COLORS.background.light,
            dark: HUBFARM_COLORS.background.dark,
        },
        font: {
            dark: HUBFARM_COLORS.font.dark,
            light: HUBFARM_COLORS.font.light,
        },
        common: {
            contentHover: HUBFARM_COLORS.common.contentHover,
        },
    },
    font: {
        family: HUBFARM_FONTS.family,
        size: {
            small: HUBFARM_FONTS.size.small,
            mediumSmall: HUBFARM_FONTS.size.mediumSmall,
            medium: HUBFARM_FONTS.size.medium,
            mediumBig: HUBFARM_FONTS.size.mediumBig,
            big: HUBFARM_FONTS.size.big,
            caption: HUBFARM_FONTS.size.caption,
            title: HUBFARM_FONTS.size.title,
            heading: HUBFARM_FONTS.size.heading,
        },
        lineHeight: {
            small: HUBFARM_FONTS.lineHeight.small,
            mediumSmall: HUBFARM_FONTS.lineHeight.mediumSmall,
            medium: HUBFARM_FONTS.lineHeight.medium,
            mediumBig: HUBFARM_FONTS.lineHeight.mediumBig,
            big: HUBFARM_FONTS.lineHeight.big,
        },
        weight: {
            light: HUBFARM_FONTS.weight.light,
            normal: HUBFARM_FONTS.weight.normal,
            bold: HUBFARM_FONTS.weight.bold,
        },
    },
    common: {
        borderRadius: {
            low: HUBFARM_BORDER_RADIUS.low,
            default: HUBFARM_BORDER_RADIUS.default,
            high: HUBFARM_BORDER_RADIUS.high,
            onlyTop: HUBFARM_BORDER_RADIUS.onlyTop,
            onlyRight: HUBFARM_BORDER_RADIUS.onlyRight,
        },
        shadow: {
            light: HUBFARM_BOX_SHADOW.light,
            default: HUBFARM_BOX_SHADOW.default,
            dark: HUBFARM_BOX_SHADOW.dark,
        },
    },
    space: {
        layout: {
            fullWidth: HUBFARM_SPACING.layout.fullWidth,
            partialWidth: HUBFARM_SPACING.layout.partialWidth,
        },
        margin: {
            smallest: HUBFARM_SPACING.margin.smallest,
            small: HUBFARM_SPACING.margin.small,
            default: HUBFARM_SPACING.margin.default,
            large: HUBFARM_SPACING.margin.large,
            largest: HUBFARM_SPACING.margin.largest,
            horizontalDefault: HUBFARM_SPACING.margin.horizontalDefault,
            verticalDefault: HUBFARM_SPACING.margin.verticalDefault,
        },
        padding: {
            smallest: HUBFARM_SPACING.padding.smallest,
            small: HUBFARM_SPACING.padding.small,
            default: HUBFARM_SPACING.padding.default,
            large: HUBFARM_SPACING.padding.large,
            largest: HUBFARM_SPACING.padding.largest,
            horizontalDefault: HUBFARM_SPACING.padding.horizontalDefault,
            verticalDefault: HUBFARM_SPACING.padding.verticalDefault,
        },
    },
    layout: {
        width: {
            full: HUBFARM_LAYOUT.width.full,
            partial: HUBFARM_LAYOUT.width.partial,
        },
        sidebar: {
            full: HUBFARM_LAYOUT.sidebar.full,
        },
        header: {
            topBar: HUBFARM_LAYOUT.header.topBar,
            menu: HUBFARM_LAYOUT.header.menu,
        },
    },
    components: {
        table: {
            header: {
                background: HUBFARM_COLORS.brand.main,
                color: HUBFARM_COLORS.font.light,
            },
            headerSecondary: {
                background: HUBFARM_COLORS.brand.main,
                color: HUBFARM_COLORS.font.light,
            },
            th: {
                background: HUBFARM_COLORS.background.light,
                color: HUBFARM_COLORS.font.dark,
            },
            row: {
                hover: HUBFARM_COLORS.common.contentHover,
            },
        },
        link: {
            colors: {
                normal: HUBFARM_COLORS.brand.main,
                hover: HUBFARM_COLORS.brand.light,
            },
        },
        header: {
            colors: {
                background: HUBFARM_COLORS.brand.main,
                text: HUBFARM_COLORS.font.light,
                menuIcon: HUBFARM_COLORS.font.light,
            },
        },
        menu: {
            colors: {
                background: HUBFARM_COLORS.background.light,
                text: HUBFARM_COLORS.font.dark,
                selected: HUBFARM_COLORS.brand.main,
            },
        },
        userMenu: {
            colors: {
                headerBackground: HUBFARM_COLORS.primary.light,
                headerText: HUBFARM_COLORS.font.dark,
                buttonBackground: HUBFARM_COLORS.background.light,
                buttonText: HUBFARM_COLORS.font.dark,
                buttonBackgroundHover: HUBFARM_COLORS.primary.main,
                triggerBackground: HUBFARM_COLORS.background.light,
                triggerText: HUBFARM_COLORS.brand.main,
                userIconBackground: HUBFARM_COLORS.primary.darkest,
                userIconText: HUBFARM_COLORS.font.light,
            },
        },
        tabs: {
            indicator: HUBFARM_COLORS.background.light,
            background: HUBFARM_COLORS.brand.main,
            color: HUBFARM_COLORS.font.light,
        },
        listItem: {
            backgroundHover: HUBFARM_COLORS.background.light,
            backgroundSelected: HUBFARM_COLORS.primary.main,
            textHover: HUBFARM_COLORS.font.dark,
            textSelected: HUBFARM_COLORS.font.light,
        },
        sidebar: {
            colors: {
                itemSelected: HUBFARM_COLORS.brand.main,
                border: HUBFARM_COLORS.brand.main,
            },
        },
        passwordSuggestionBox: {
            container: {
                background: HUBFARM_COLORS.background.light,
                text: HUBFARM_COLORS.font.dark,
            },
            arrow: {
                background: HUBFARM_COLORS.background.light,
            },
            rule: {
                iconSuccess: HUBFARM_COLORS.success.main,
                iconError: HUBFARM_COLORS.error.main,
                text: HUBFARM_COLORS.font.dark,
            },
        },
        logoutButton: {
            background: HUBFARM_COLORS.grey.lightest,
            backgroundHover: HUBFARM_COLORS.grey.light,
            text: HUBFARM_COLORS.font.dark,
        },
    },
};
export function createMyTheme(options) {
    return createTheme({
        palette: {
            primary: {
                light: HUBFARM_COLORS.primary.light,
                main: HUBFARM_COLORS.primary.main,
                dark: HUBFARM_COLORS.primary.dark,
            },
            secondary: {
                light: HUBFARM_COLORS.brand.light,
                main: HUBFARM_COLORS.brand.main,
                dark: HUBFARM_COLORS.brand.dark,
            },
            text: {
                primary: HUBFARM_COLORS.font.dark,
                secondary: HUBFARM_COLORS.font.light,
            },
        },
        typography: {
            fontFamily: HUBFARM_FONTS.family,
            h5: {
                fontSize: '1.25rem',
                lineHeight: '1.5',
            },
            subtitle1: {
                lineHeight: '1.25',
            },
            body1: {
                color: '#4a4a4a',
            },
            caption: {
                color: '#333',
                fontSize: '0.625rem',
            },
            h4: {
                fontSize: '1.5rem',
                fontWeight: 500,
                color: 'black',
            },
        },
        overrides: {
            MuiAutocomplete: {
                noOptions: {
                    color: HUBFARM_COLORS.font.dark,
                    fontSize: HUBFARM_FONTS.size.medium,
                },
            },
            MuiInput: {
                underline: {
                    '&:after, &:before': {
                        borderBottom: border('currentColor'),
                    },
                    '&:hover:not($disabled):not($focused):not($error):before': {
                        borderBottomColor: 'currentColor',
                    },
                },
            },
            MuiFormHelperText: {
                root: {
                    marginTop: 2,
                    fontSize: '0.70rem',
                    lineHeight: '0.9em',
                },
            },
            MuiFormLabel: {
                root: {
                    color: HUBFARM_COLORS.grey.light,
                    '&$disabled': {
                        color: HUBFARM_COLORS.font.dark,
                    },
                    '&$focused': {
                        color: HUBFARM_COLORS.font.dark,
                    },
                },
            },
            MuiInputLabel: {
                formControl: {
                    color: HUBFARM_COLORS.font.dark,
                },
            },
            MuiStepLabel: {
                root: {
                    textTransform: 'uppercase',
                },
                label: {
                    color: HUBFARM_COLORS.font.dark,
                },
                completed: {
                    '&:hover': {
                        cursor: 'pointer',
                        textDecoration: 'underline',
                    },
                },
                active: {
                    fontWeight: `${HUBFARM_FONTS.weight.bold} !important`,
                },
                '&$disabled': {
                    color: HUBFARM_COLORS.grey.light,
                },
            },
            MuiStepIcon: {
                root: {
                    '& text': {
                        fill: HUBFARM_COLORS.font.light,
                        fontSize: HUBFARM_FONTS.size.mediumSmall,
                        fontWeight: HUBFARM_FONTS.weight.bold,
                    },
                },
                completed: {
                    color: `${HUBFARM_COLORS.primary.main} !important`,
                },
                active: {
                    color: `${HUBFARM_COLORS.primary.main} !important`,
                },
            },
            MuiInputBase: {
                input: {
                    padding: toCssValue([7, 0, 2]),
                    fontSize: HUBFARM_FONTS.size.mediumBig,
                },
            },
            MuiRadio: {
                root: {
                    color: HUBFARM_COLORS.font.dark,
                },
            },
            MuiSelect: {
                select: {
                    padding: toCssValue([7, 0, 6]),
                },
            },
        },
        ...options,
    });
}
export const hubfarmTheme = createMyTheme(hubfarmThemeConf);
//# sourceMappingURL=hubfarmTheme.js.map